import { PluginListenerHandle } from '@capacitor/core';
import { ScreenOrientation } from '@capawesome/capacitor-screen-orientation';
import { isPlatform } from '@ionic/core';
import { useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';
import { sleep } from './async';
import { logger } from './logger';

interface WindowSize {
  width: number;
  height: number;
}

const useWindowSizeWithRotation = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const size = useWindowSize();

  useEffect(() => {
    let subscription: PluginListenerHandle;

    if (isPlatform('hybrid')) {
      try {
        subscription = ScreenOrientation.addListener(
          'screenOrientationChange',
          async () => {
            // we need a small delay before grabbing the window dimensions because
            // the dimensions may not have updated when the subscription fires, particularly
            // when resuming the app
            await sleep(100);
            setWindowSize({
              height: window.innerHeight,
              width: window.innerWidth,
            });
          }
        );
      } catch (error) {
        logger.error('error subscribing to screen orientation change', {
          error,
        });
      }
    }

    return () => {
      subscription?.remove();
    };
  }, []);

  useEffect(() => {
    if (!isPlatform('hybrid')) {
      setWindowSize(size);
    }
  }, [size]);

  return windowSize;
};

export { useWindowSizeWithRotation };
